/**
 * 
 * key
 * 
 */


const key = 'Z2V0UGhvdG9ncmFwaGVyQXBwRGV0YWlscw=='

export default key 